import BigNumber from 'bignumber.js';
import { replaceZeroWithDash, formatNumberToLocale } from './numberFormatter';
export default (function (position, symbol) {
  var formattedPosition = Object.assign({}, position);
  formattedPosition.Hold = formatValue(position.Hold, symbol);
  formattedPosition.PendingDeposits = formatValue(position.PendingDeposits, symbol);
  formattedPosition.Amount = formatValue(position.Amount, symbol);
  formattedPosition.rawAmount = position.Amount;
  formattedPosition.AvailableBalance = formattedPosition.Amount;
  if (position.Amount !== 0 && position.Hold !== 0) {
    var amount = new BigNumber(position.Amount);
    var availableBalance = amount.minus(new BigNumber(position.Hold));
    formattedPosition.AvailableBalance = formatNumberToLocale(availableBalance, symbol);
  }
  return formattedPosition;
});
var formatValue = function formatValue(value, symbol) {
  if (value === 0) {
    return replaceZeroWithDash(value);
  }
  return formatNumberToLocale(value, symbol);
};